import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listChartsService } from "../services/listCharts.service";

export const useChartsQuery = (filters) => {
  const fetchData = useFetch();
  const [dailyReview, setDailyReview] = useState(null);
  const [annualPlanCompliance, setAnnualPlanCompliance] = useState(null);
  const [trainingPlanCompliance, setTrainingPlanCompliance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchCharts = async () => {
      setLoading(true);
      try {
          const { data } = await listChartsService(fetchData)(filters);
        setDailyReview(data.dailyReview);
        setAnnualPlanCompliance(data.annualPlanCompliance);
        setTrainingPlanCompliance(data.trainingPlanCompliance);
      } catch (error) {
        console.error("Error fetching charts:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchCharts, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters]);

  return {
    dailyReview,
    annualPlanCompliance,
    trainingPlanCompliance,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
